
import * as React from "react";
import { IUserRestaurantListItem } from "../../interfaces/IRestaurant";
import { ISetUrl } from "../../AppMain";
import { Api } from "../../lib/Api";
import Header from "../Header";
import Footer from "../Footer";
import RestaurantMap from "./RestaurantMap";
import ViewRestaurant, { IViewForViewRestaurant } from "./ViewRestaurant";
import { Order } from "./Order";
import { Url } from "../../../avernus/url/source/Url";
import { Lng } from "../../../languages/Languages";
import SelectProfessionalCategory from "./SelectProfessionalCategory";
import OfferListTitle from "./OfferListTitle";
import ProfessionalRow from "./ProfessionalRow";
import LoaderComp from "../../../avernus/loader/source/LoaderComp";

interface IUserRestaurantListProps {
    setUrl          : ISetUrl
    sortingMethod   : ISortMethod
    view            : 'with_image'|'without_image'|'googlemap'|'ordered_with_image'
    title           : string
    headerImg       ?: string
    filter          ?: string
    justLiked       ?: boolean
    justOrdered     ?: boolean
    shortByEnabled  ?: boolean
    openedId        ?: number
    viewForViewRestaurant :IViewForViewRestaurant
    isOpenToday     ?: boolean
}

type ISortMethod = 'nearYou'|'nearYouAll'|'rateing';

interface IUserRestaurantListState {
    items                : Array<IUserRestaurantListItem>
    version              : number;
    orderBy              : 'ASC'|'DESC'
    longitude            : number
	latitude                : number
    openedId             : number
    currentItem          : IUserRestaurantListItem
    viewForViewRestaurant: IViewForViewRestaurant
    selectCategory       : Array<ISelectCategory>
}

interface IGetListResult {
    items:Array<IUserRestaurantListItem>
}

interface ISelectCategory{
    id: Number
    name: string
    img: string
}

interface IXhrUrls{
    list:string
}

export default class UserRestaurantList extends React.Component<IUserRestaurantListProps, IUserRestaurantListState>{


    private idName : string;
    private xhrUrls: IXhrUrls;

    constructor(props:IUserRestaurantListProps){
        super(props);
        this.idName             = 'restaurant';
        this.xhrUrls = {
            list:           '/user/restaurant/getOfferList',
        }
        this.state = {
            version                 : 0,
            items                   : null,
            orderBy                 : 'ASC',
            longitude               : 0,
            latitude                : 0,
          //  openedId                : this.props.openedId !== undefined?this.props.openedId:null,
            openedId                : 0,
            currentItem             : this.props.openedId !== undefined?Order.getRestaurant():null,
            viewForViewRestaurant   : this.props.viewForViewRestaurant,
            selectCategory          : []
        };
    }


    private init(){
        Api.getGeoLocation((position)=>{
            if ( position !== null ) {
                if ( this.state.longitude !== position.coords.longitude || this.state.latitude !== position.coords.latitude ) {
                    this.setState({
                        longitude: position.coords.longitude,
                        latitude: position.coords.latitude
                    }, () =>{
                        this.getList();
                    });
                }else{
                    this.getList();
                }
            }else{
                this.getList();
                alert(Lng.get('user_restlist_enalbegeo'));
            }
        });
    }

    private getList(){
        Api.call(this.xhrUrls.list, {
            sortingMethod : this.props.sortingMethod,
            orderBy       : this.state.orderBy,
            longitude     : this.state.longitude,
            latitude      : this.state.latitude,
            justLiked     : this.props.justLiked!==undefined && this.props.justLiked,
            justOrdered   : this.props.justOrdered!==undefined && this.props.justOrdered,
            filter        : this.props.filter !== undefined?this.props.filter:'',
            isOpenToday   : this.props.isOpenToday !== undefined && this.props.isOpenToday,
            addressCountry: Api.getUserCountry(),
            addressState  : Api.getUserState(),
            offerTypeId   : this.state.selectCategory['id']
        }, (result:IGetListResult)=>{
            console.log(result);
            this.setState({
                items: result.items,
                version: (this.state.version + 1)
            });
        });
    }


    private openRestaurantClickHandler(evt, id:number): void {
        evt.preventDefault();
        let items                               = this.state.items;
        let currentItem:IUserRestaurantListItem = null;
        for (var key in items) {
            var item = items[key];
            if ( item.id === id) {
                currentItem = item;
                break;
            }
        }

        this.setState({
            openedId   : id,
            currentItem: currentItem
        });
    }

    private changedOrderByHandler(): void {
        this.setState({
            orderBy: this.state.orderBy==='ASC'?'DESC':'ASC'
        }, () =>{
            this.init();
        });
    }

    private changeViewForViewRestaurant(viewForViewRestaurant:IViewForViewRestaurant): void {
        this.setState({
            viewForViewRestaurant: viewForViewRestaurant
        });
    }

    public changedCategory(item){
        this.setState({
            selectCategory: item
        }, () => {
            this.init();
        })

    }


    render() {
        let title = this.state.openedId !== null?undefined:this.props.title;
        let titleIconImage = undefined;
        let headerImg   = this.props.headerImg;
        let currentItem = this.state.currentItem;
        if ( currentItem !== null && currentItem.photos.length > 0 ) {
            headerImg = currentItem.photos[0];
        }
        let pageImg = null;
        if ( this.props.view === 'googlemap' ) {
            titleIconImage = 'img/szuro_icon.svg';
            pageImg   = headerImg;
            headerImg = null;
        }
        let onlyBackBtnText = Lng.get('back_to_all_offers');
        if ( Url.isUrl(/user\/submit-order/) === true ) {
            onlyBackBtnText = Lng.get("Back to the restaurant's offers!");
        }

        return (
            <>
                {this.state.openedId ?
                    <div className={'container content_section offer_section offer_section_view '  + this.props.view}>
                        <Header
                            key={'header_' + this.state.openedId}
                            title = {''}
                            setUrl={this.props.setUrl}
                        />
                        <ViewRestaurant
                            setUrl={this.props.setUrl}
                            key={this.state.openedId+'_'+this.state.viewForViewRestaurant}
                            restaurantId={this.state.openedId}
                            view={ this.state.viewForViewRestaurant }
                        />
                    </div> :
                    this.state.selectCategory.length == 0 ?
                    <SelectProfessionalCategory changed = {(item) => this.changedCategory(item)} setUrl={this.props.setUrl} /> :
                    <div className={ this.props.view +'_page' } style={pageImg !== null ? {
                        backgroundImage: `url(${pageImg})`
                    } : {}}>
                        <Header
                            key={'header_' + this.state.openedId}
                            title = {'professionals nearby'}
                            titleIconImage={titleIconImage}
                            titleIconImageWidth={22}
                            setUrl={this.props.setUrl}
                            orderBy={this.state.orderBy}
                            headerImg={headerImg}
                            shortByEnabled={this.props.shortByEnabled !== undefined && this.props.shortByEnabled === true}
                            changedOrder={() => this.changedOrderByHandler()}
                            category={this.state.selectCategory}
                        />

                        <div className={'container content_section offer_section '  + this.props.view}>

                            { this.props.view==='with_image'?this.listItemWithImage():'' }
                            { this.props.view==='ordered_with_image'?this.listItemWithImage(true):'' }
                            { this.props.view==='without_image'?this.listItemWithoutImage():'' }
                            { this.props.view==='googlemap'?this.listGoolgeMap():'' }
                        </div>

                        <Footer
                            setUrl={this.props.setUrl}
                            onlyBackBtnText={this.state.openedId>0?onlyBackBtnText:undefined}
                            backBtnClickHandler={ e => {
                                if ( Url.isUrl(/user\/submit-order/) === true ) {
                                    let restaurantId = Order.getRestaurantId();
                                    Order.setEmptyRestaurant();
                                    Order.setEmptyOffer();
                                    this.props.setUrl('/user/offers/'+restaurantId, { restaurantId: restaurantId});
                                }else{
                                    this.setState({
                                        openedId: null,
                                        currentItem: null
                                    });
                                }
                            } }

                        />
                    </div>
                }

            </>

        );
    }

    private toggleLikeClickHandler(evt, restaurantId:number, index:number): void {
        evt.preventDefault();
        if ( Api.isFrontUser() ) {
            Api.call('/user/restaurant/toggleLike', {
                restaurantId: restaurantId
            }, (result) =>{
                if ( result.success === true ) {
                    let items = this.state.items;
                    if ( this.props.justLiked !== undefined && this.props.justLiked === true ) {
                        items.splice(index, 1);
                    }else{
                        items[index].liked = !items[index].liked;
                    }
                    this.setState({
                        items: items
                    });
                }
            });
        }
    }

    private listGoolgeMap(){
        return <section className={this.idName+"_list" + ' goolgemaps'}>
            {this.state.items === null ? <div style={{
                paddingTop: '50px'
            }}>
                <LoaderComp show={true} />
            </div> : <>
                <RestaurantMap
                    items={this.state.items}
                    toggleLikeClickHandler={ (evt, restaurantId, index) => this.toggleLikeClickHandler(evt, restaurantId, index) }
                    openRestaurantClickHandler={ (evt,id) => this.openRestaurantClickHandler(evt,id) }
                    showLikeBtn={true}
                    showStartNavigationBtn={false}
                    centerPosition={{
                        lat: this.state.latitude,
                        lng: this.state.longitude
                    }}
                />
            </>}
        </section>;
    }

    private selectProfessionalProfile(id){
        this.setState({
            openedId   : id
        });
    }

    private listItemWithImage(withoutPercent:boolean=false) {
        let items = this.state.items;
        return <section className={this.idName+"_list"}>
            {items === null ? <div style={{
                paddingTop: '50px'
            }}>
                <LoaderComp show={true} />
            </div> : <>
                    { items.length === 0 ?<div className="no_result">
                        <img src="img/not-found.png" width="250" alt=""/><br />
                        {Lng.get('user_restlist_noaoffernearby')}
                    </div>:'' }

                    {items.map((item, index) => (
                        <ProfessionalRow item={item} selectProfessionalProfile = {(id) => this.selectProfessionalProfile(id)}/>
                    ))}
                </>}
        </section>;
    }

    private listItemWithoutImage() {
        let items = this.state.items;
        return <section className={this.idName+"_list"}>
            {items === null ? <div style={{
                paddingTop: '50px'
            }}>
                <LoaderComp show={true} />
            </div> : <>
                    { items.length === 0 ?<div style={{
                        paddingTop: '50px'
                    }}>
                        {Lng.get('user_restlist_emptyresult')}
                    </div>:'' }
                    {items.map((item, index) => {
                        return <div className="restaurant_row" key={'restaurant_row_'+index} id={this.idName+'_row_'+item.id}>
                            <div className="row">
                                <div className="col logo_box" onClick={e => this.openRestaurantClickHandler(e, item.id)}>
                                    { item.img !== null?
                                        <img src={item.img} alt=""/>
                                    :'' }
                                </div>
                                <div className="col text_block">
                                    <div className="row title_box">
                                        <div className="left_box" onClick={e => this.openRestaurantClickHandler(e, item.id)}>
                                            <h3>
                                                {item.name}
                                            </h3>
                                            <div>
                                                <strong>{item.restaurantTypeName}</strong>
                                            </div>
                                            <div>
                                                { item.rateing >= 1?<img className="rateing_star" src="img/star_icon.svg" width="15" alt=""/>:'' }
                                                { item.rateing >= 2?<img className="rateing_star" src="img/star_icon.svg" width="15" alt=""/>:'' }
                                                { item.rateing >= 3?<img className="rateing_star" src="img/star_icon.svg" width="15" alt=""/>:'' }
                                                { item.rateing >= 4?<img className="rateing_star" src="img/star_icon.svg" width="15" alt=""/>:'' }
                                                { item.rateing >= 5?<img className="rateing_star" src="img/star_icon.svg" width="15" alt=""/>:'' }
                                            </div>
                                        </div>
                                        <div className="right_box">
                                            <div>
                                                <a className="like_box" onClick={ (e) => { this.toggleLikeClickHandler(e, item.id, index); } }>
                                                    <img src="img/facourite_icon.svg" width={28} alt=""/>
                                                </a>
                                            </div>
                                            <div>
                                                <strong>{ item.distance.toFixed(0) } km</strong>
                                            </div>

                                        </div>
                                    </div>
                                    <div className="row offer_num_box" onClick={e => this.openRestaurantClickHandler(e, item.id)}>
                                        <strong>
                                            { item.offerNum} {Lng.get('user_restlist_left')}
                                        </strong> - {Lng.get('user_restlist_today')} { item.openingTodayStart }-{item.openingTodayEnd }
                                    </div>
                                    <div className="row restaurant_types_box" onClick={e => this.openRestaurantClickHandler(e, item.id)}>
                                        <div>
                                            {
                                                item.offerTypeIds.map((id, index)=>{
                                                    return <span key={'rtype_'+index} >
                                                        { id === 1?
                                                            <img src="img/box_icon_kicsi.svg" width="23" alt=""/>
                                                        :'' }
                                                        { id === 2?
                                                            <img src="img/tal_icon.svg" width="25" alt=""/>
                                                        :'' }
                                                        { id === 3?
                                                            <img src="img/happy_hour_icon.svg" width="18" alt=""/>
                                                        :'' }

                                                    </span>
                                                })
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>;
                    })}
                </>}
        </section>;
    }
}
